
import { defineComponent, ref } from "vue";
import {
  IonIcon,
  IonLabel,
  IonPage,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonText
} from "@ionic/vue";
import { locationOutline, cardOutline } from "ionicons/icons";
import LogoHeader from "../../components/LogoHeader.vue";


export default defineComponent({
  name: "SettingsTabsPage",
  components: {
    IonIcon,
    IonLabel,
    IonPage,
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonText,
    LogoHeader
  },
  setup() {
    const selectedTab = ref('billing')
    const beforeTabChange = () => {
      // do something before tab change
    };
    const afterTabChange = () => {
      // do something after tab change
    };
    return {
      selectedTab,
      locationOutline,
      cardOutline,
      beforeTabChange,
      afterTabChange,
    };
  },
  mounted() {
    this.$store.dispatch("initFromStorage");
    if (this.$route.path.includes('counties')) {
      this.selectedTab = 'counties'
    } else if (this.$route.path.includes('billing')) {
      this.selectedTab = 'billing'
    }
  },
  computed: {
    selectedCounty(): any {
      return this.$store.state.selectedCounty;
    },
  },
});
